import BaseApi from '@/api/base-api'

class CommonApi extends BaseApi {
  fetchGlobalConfiguration = () => {
    return this.request(
      {
        path: `${this.uri}/configurations`,
        method: 'GET',
      },
      {
        options: {
          hideMessage: true,
          attachReCaptchaToken: 'configurations',
        },
      }
    )
  }
}

export default new CommonApi('')
